package nl.volleyplanner.web.base.component

import kotlinx.dom.addClass
import kotlinx.dom.removeClass
import kotlinx.html.FORM
import kotlinx.html.FlowContent
import kotlinx.html.form
import kotlinx.html.js.onInputFunction
import kotlinx.html.js.onSubmitFunction
import kotlinx.html.onInput
import kotlinx.html.org.w3c.dom.events.Event
import nl.volleyplanner.web.launchAsync
import org.w3c.dom.HTMLFormElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.asList

/**
 * @param customValidityFunction: function that is called before the form is submitted.
 *      Interrupts submission if this function marks the Form to be invalid and
 *      FormElement.checkValidity() returns false
 * @param validSubmitFunction: function that is called when the form is valid and submitted
 * @param onSubmitErrorFunction: function that is called when the form submission results in an exception
 */
fun FlowContent.validatingForm(
    customValidityFunction: ((HTMLFormElement) -> Unit)? = null,
    validSubmitFunction: suspend (Event, HTMLFormElement) -> Unit,
    onSubmitErrorFunction: ((Throwable, HTMLFormElement) -> Unit)? = null,
    block: FORM.() -> Unit
) {
    form {
        novalidate = true
        onInputFunction = { event ->
            val formElement = event.currentTarget as HTMLFormElement
            formElement.removeClass("was-validated")
        }
        onSubmitFunction = { event ->
            event.preventDefault()
            val formElement = event.currentTarget as HTMLFormElement

            customValidityFunction?.invoke(formElement)

            if (!formElement.checkValidity()) {
                event.stopPropagation()
                formElement.addClass("was-validated")
            } else {
                launchAsync {
                    validSubmitFunction(event, formElement)
                }.onComplete {
                    formElement.addClass("was-validated")
                }.onError { error ->
                    formElement.addClass("was-validated")
                    onSubmitErrorFunction?.invoke(error, formElement)
                }
            }

        }
        block()
    }
}